import { sectionNav } from "@/mocks/community";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-200 border-t-4 border-primary-500">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-md flex items-center justify-center font-label text-lg bg-primary-500 text-background-50">
                黑
              </span>
              <span className="font-label text-xl text-foreground-950">黑料 · 吃瓜情报站</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚焦明星网红黑料与吃瓜爆料，整理最新热点、人物档案、热门专题与瓜田黑话，
              帮你在信息碎片里快速抓住重点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-700 border border-background-300">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-700 border border-background-300">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-700 border border-background-300">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-label text-lg text-foreground-950">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 md:grid-cols-1 gap-x-4 gap-y-2.5">
              {sectionNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-label text-lg text-foreground-950">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-primary-600" />
                站内内容含未证实信息，仅供娱乐讨论
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5 text-primary-600" />
                爆料时间线按日更新，保留来源口径
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-600" />
                请勿传播不实内容，理性吃瓜
              </li>
            </ul>
            <a
              href="#subscribe"
              className="mt-5 inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-notification-3-line" />
              订阅吃瓜更新
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 黑料 · 吃瓜情报站 · 本页为内容示例站点
          </p>
          <p className="text-xs text-foreground-500">
            明星黑料 · 网红黑料 · 吃瓜爆料汇总
          </p>
        </div>
      </div>
    </footer>
  );
}